<template>
  <div>
    <div v-if="isValidArray(labels)">
      <ul
        class="time-range__labels"
        :class="{ 'time-range__labels-mt': routeName === 'UsagePolicy' }"
      >
        <li
          v-for="(label, index) in labels"
          :key="`label-${index}`"
          class="time-range__label"
          :class="{ 'time-range__label--remove': remove }"
        >
          <span>{{ label.text }}</span>
          <button
            v-if="remove"
            type="button"
            class="time-range__btn"
            @click="handleRemoveTimeRange(label.key)"
          >
            <v-icon>close</v-icon>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { isArray } from 'utils/functions'
import { renderLabels } from 'utils/timePolicy'

export default {
  name: 'Labels',
  props: {
    remove: {
      type: Boolean,
      default: false
    },
    timePolicyType: {
      type: String,
      required: true
    },
    intervals: {
      type: Array
    },
    setLabels: {
      type: Boolean
    }
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  },
  data () {
    return {
      namespace: 'Views.UsagePolicyPage.timeRangeComboBox',
      labels: []
    }
  },
  methods: {
    isValidArray (val) {
      return isArray(val)
    },

    // numberToDayOfWeek (number) {
    //   const days = {
    //     '0': this.$t(`${this.namespace}.daysOfWeekShortened`)[0].name,
    //     '1': this.$t(`${this.namespace}.daysOfWeekShortened`)[1].name,
    //     '2': this.$t(`${this.namespace}.daysOfWeekShortened`)[2].name,
    //     '3': this.$t(`${this.namespace}.daysOfWeekShortened`)[3].name,
    //     '4': this.$t(`${this.namespace}.daysOfWeekShortened`)[4].name,
    //     '5': this.$t(`${this.namespace}.daysOfWeekShortened`)[5].name,
    //     '6': this.$t(`${this.namespace}.daysOfWeekShortened`)[6].name
    //   }

    //   return days[number]
    // },

    // renderLabels () {
    //   console.log('DEBUG renderLabels')
    //   const intervalsArray = this.intervals
    //     .sort((a, b) => {
    //       if (a.dayOfWeek < b.dayOfWeek) return -1
    //       if (a.dayOfWeek > b.dayOfWeek) return 1
    //       return 0
    //     })
    //     .map(interval => {
    //       const key = `${interval.startTime}-${interval.endTime}`
    //       return {
    //         key,
    //         ...interval
    //       }
    //     })

    //   const dayOfWeekArray = intervalsArray.map(interval => interval.key)
    //   const intervalsGroup = removeDuplicateItemsInArray(dayOfWeekArray).map(key => {
    //     const intervals = intervalsArray.filter(i => i.key === key)
    //     const startTime = intervals[0].startTime
    //     const endTime = intervals[0].endTime
    //     const daysOfWeek = intervals.map(i => {
    //       return {
    //         text: this.numberToDayOfWeek(i.dayOfWeek),
    //         number: i.dayOfWeek
    //       }
    //     })

    //     return {
    //       key,
    //       daysOfWeek,
    //       startTime,
    //       endTime
    //     }
    //   })

    //   const timePolicyType = this.timePolicyType
    //   const from = this.$t(`${this.namespace}.policyCreatedFrom`)
    //   const to = this.$t(`${this.namespace}.policyCreatedTo`)

    //   if (timePolicyType === 'customDays') {
    //     this.labels = intervalsGroup.map(interval => {
    //       const daysTextConcat = interval.daysOfWeek.reduce((acc, item, index) => {
    //         const comma = index < interval.daysOfWeek.length - 1 ? ', ' : ' '
    //         acc += `${item.text}${comma}`
    //         return acc
    //       }, '')

    //       const daysNumberConcat = interval.daysOfWeek.reduce((acc, item) => {
    //         acc += `${item.number}`
    //         return acc
    //       }, '')

    //       const key = interval.key
    //       let text = `${daysTextConcat}${from} ${interval.startTime} ${to} ${interval.endTime}`

    //       if (daysNumberConcat === '0123456') {
    //         const daysOfWeekLastItem = interval.daysOfWeek.length - 1
    //         const startDay = interval.daysOfWeek[0].text
    //         const endDay = interval.daysOfWeek[daysOfWeekLastItem].text
    //         text = `${startDay} > ${endDay} ${from} ${interval.startTime} ${to} ${interval.endTime}`
    //         return { key, text }
    //       }

    //       return { key, text }
    //     })
    //   }

    //   if (timePolicyType === 'workingDays') {
    //     this.labels = intervalsGroup
    //     this.labels = intervalsGroup.map(interval => {
    //       const key = interval.key
    //       const daysOfWeekLastItem = interval.daysOfWeek.length - 1
    //       const startDay = interval.daysOfWeek[0].text
    //       const endDay = startDay !== interval.daysOfWeek[daysOfWeekLastItem].text
    //         ? `> ${interval.daysOfWeek[daysOfWeekLastItem].text}`
    //         : ''
    //       const text = `${startDay} ${endDay} ${from} ${interval.startTime} ${to} ${interval.endTime}`
    //       return { key, text }
    //     })
    //   }
    // },

    renderLabels () {
      this.labels = renderLabels(this, this.intervals, this.timePolicyType)
    },

    handleRemoveTimeRange (key) {
      if (key) {
        const [startTime, endTime] = key.split('-')
        this.$emit('removeTimeRange', { startTime, endTime })
      }
    }
  },
  watch: {
    setLabels () {
      this.renderLabels()
    }
  },
  mounted () {
    this.renderLabels()
  }
}
</script>

<style lang="scss" scoped>
.time-range__labels {
  list-style-type: none;
  margin: 0;
  padding: 0;

  &.time-range__labels-mt {
    margin: 12px 0 0;
  }
}

.time-range__label {
  align-items: center;
  border-radius: 16px;
  background-color: $gray-3;
  display: inline-flex;
  margin: 4px 8px 4px 0;
  padding: 4px 12px;

  &.time-range__label--remove {
    padding-right: 6px;
  }
}

.time-range__btn {
  align-items: center;
  background-color: $gray-5;
  border-radius: 50%;
  display: flex;
  height: 18px;
  justify-content: center;
  margin-left: 8px;
  width: 18px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

  .v-icon {
    color: $gray-3;
    font-size: 14px;
    font-weight: bold;
  }

  &:hover {
    background-color: $gray-6;
  }
}
</style>
